<template>
  <section class="third-frame">
    <el-row class="title" type="flex" align="middle">
      <el-col :span="8">
        Доступные погрузки.<br />
        Если вы еще не с нами позвоните на номер
      </el-col>
      <el-col :span="8" class="middle">
        <h2>8 800 250-75-31</h2>
        <span>звонок бесплатный</span>
      </el-col>
      <el-col :span="8">
        Мы работаем по хартии<br />
        и без перегруза
      </el-col>
    </el-row>
    <bid-info
      v-for="bid in bids"
      :key="bid.id"
      :bid="bid"
      :freights-types="freightsTypes"
      :bids-types="bidsTypes"
    />
  </section>
</template>

<script>
import BidInfo from './BidInfo'
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'ThirdFrame',
  components: { BidInfo },
  mixins: [shippingMixin],
  props: {
    bids: {
      type: Array,
      default: () => [],
    },
    freightsTypes: {
      type: Object,
      default: () => {},
    },
    bidsTypes: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
.third-frame
  font-family: 'Roboto', sans-serif;
  padding: 100px 100px;
  background-color: #fff;
  height: 100%;
  color: #000000;
  .title
    .el-col
      font-size: 24px;
      &.middle
        text-align: center;
        h2
          font-size: 70px;
          margin: 0;
          line-height: 1;
          font-weight: bold;
        span
          font-size: 20px;
      &:last-child
        font-size: 32px;
        font-weight: bold;
        text-align: right;
</style>
